import { NextImage } from "@ecco/ui/next-image";
import { carrierIcons } from "./icons";
import { memo } from "react";
interface CarrierIconProps {
    name: string;
}

// Component is wrapped in memo to prevent unnecessary re-renders from the checkout form changing state.
// Every change to an input field will cause a re-render of the checkout form. If browser has cache disabled this will refetch the image from the server every time, which is not ideal.
// Memoizing the component will prevent this behavior because the component never actually leaves the DOM.
export const CarrierIcon = memo(({ name }: CarrierIconProps) => {
    const iconData = carrierIcons[name] ?? carrierIcons["fallback"];
    const height = iconData.height ?? "35px";
    return (
        <>
            <NextImage
                sx={{
                    display: "inline-flex",
                    width: "42px",
                    height,
                }}
                key={name}
                src={iconData?.path}
                // It's SVGs or pre-optimized png/jpg. No need to resize or compress.
                unoptimized
                alt={name}
            />
        </>
    );
});

CarrierIcon.displayName = "CarrierIcon";
